import { Injectable, Injector } from "@angular/core";
import { IProvideOptions } from "./options-provider.interface";
import { LoanPurposeOptionsProvider } from "./loan-purpose-options-provider";
import { LoanPurposeOptionsProviderV2 } from "./loan-purpose-options-providerv2";
import { DefaultPropertyTypeOptionsProvider } from "./default-property-type-options-provider";
import { OccupancyOptionsProvider } from "./occupancy-options-provider";

@Injectable()
export class OptionsProviderFactory {

  constructor(private readonly _injector: Injector) {
  }

  create = (providerType: OptionsProviderTypes): IProvideOptions | null => {
    switch(providerType) {
      case OptionsProviderTypes.LoanPurpose:
        return this._injector.get(LoanPurposeOptionsProvider);
      case OptionsProviderTypes.LoanPurposeV2:
        return this._injector.get(LoanPurposeOptionsProviderV2);
      case OptionsProviderTypes.PropertyType:
        return this._injector.get(DefaultPropertyTypeOptionsProvider);
      case OptionsProviderTypes.Occupancy:
        return this._injector.get(OccupancyOptionsProvider);
      default:
        return null;
    }
  }
}

export enum OptionsProviderTypes {
  LoanPurpose = "LoanPurpose",
  LoanPurposeV2 = "LoanPurposeV2",
  PropertyType = "PropertyType",
  Occupancy = "Occupancy"
}
